export const UNITTYPE_DELETE_OPEN_MODAL = "UNITTYPE_DELETE_OPEN_MODAL";
export const UNITTYPE_DELETE_REQUEST = "UNITTYPE_DELETE_REQUEST";
export const UNITTYPE_DELETE_RESULT = "UNITTYPE_DELETE_RESULT";
